// Try the default import instead of named import
import clarity from '@microsoft/clarity';

export const initClarity = () => {
  // Replace 'YOUR_PROJECT_ID' with your actual project ID
  clarity.init('s6v3h7x30o');
};

// Optional: Custom event tracking
export const trackEvent = (eventName, customData = {}) => {
  clarity.event(eventName, customData);
};

// Optional: Set custom tags
export const setUserTag = (key, value) => {
  clarity.set(key, value);
};